import { useEffect, useState } from "react";
import Icon from "../Icon";
import { useConfirmar } from "../Confirmar";
import { hhmm } from "../../utils/hora";

// «Fichar ahora» dentro de la pantalla de asistencias: el estado (dentro o fuera) y el
// boton que ficha, sin tener que volver a Inicio. Antes, quien miraba su jornada y veia que
// le faltaba una salida tenia que ir a otra pantalla para fichar.
//
// Recibe el estado de useFichaje desde App (el mismo que el widget de Inicio y la cabecera):
// si cada uno tuviera su propio hook, fichar en uno dejaria a los otros desactualizados.
//
// Pide confirmacion, como el boton de la cabecera: un roce no debe crear un fichaje real que
// luego haya que corregir por el flujo de solicitudes de Odoo.
export default function FicharAhora({ fichaje }) {
  const [pedir, dialogo] = useConfirmar();
  const [pulsado, setPulsado] = useState(false);
  useEffect(() => { if (!fichaje?.fichando) setPulsado(false); }, [fichaje?.fichando]);

  // Sin el estado de fichaje (otra pantalla que no lo pasa) o sin Odoo conectado no hay nada
  // que ofrecer aqui: el widget de Inicio es quien conecta la cuenta.
  if (!fichaje || fichaje.conectado === null || fichaje.conectado === undefined) return null;
  if (fichaje.conectado === false) {
    return (
      <span title="Conecta tu cuenta de Odoo desde Inicio para poder fichar"
        style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, color: "var(--text3)" }}>
        <Icon name="plug" size={11} color="var(--text3)" />Odoo sin conectar
      </span>
    );
  }

  const dentro = fichaje.estado === "dentro";
  const desde = dentro ? hhmm(fichaje.desde, null) : null;
  const ocupado = !!fichaje.fichando || pulsado;

  const fichar = async () => {
    const ok = await pedir({
      titulo: dentro ? "¿Fichar la salida ahora?" : "¿Fichar la entrada ahora?",
      mensaje: dentro
        ? "Se registra tu salida en Odoo con la hora de ahora."
        : "Se registra tu entrada en Odoo con la hora de ahora.",
      etiquetaOk: dentro ? "Fichar salida" : "Fichar entrada",
    });
    if (!ok) return;
    setPulsado(true);
    await fichaje.fichar();
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8, position: "relative" }}>
      <span role="status" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11.5,
        fontWeight: 600, color: dentro ? "var(--green-text, #15803d)" : "var(--text2)" }}>
        <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: "50%", flexShrink: 0,
          background: dentro ? "var(--green, #22c55e)" : "var(--red, #ef4444)" }} />
        {dentro ? `Dentro${desde ? ` desde las ${desde}` : ""}` : "Fuera"}
      </span>
      <button type="button" className="btn" onClick={fichar} disabled={ocupado}
        aria-label={ocupado ? "Fichando…"
          : dentro ? `Fichar ahora: ficha tu salida, dentro${desde ? ` desde las ${desde}` : ""}`
                   : "Fichar ahora: ficha tu entrada, fuera de jornada"}
        title={dentro ? "Ficha tu salida en Odoo" : "Ficha tu entrada en Odoo"}
        style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 11px", borderRadius: 9,
          border: "1px solid var(--accent)", background: "var(--accent-bg)", color: "var(--accent)",
          fontSize: 11.5, fontWeight: 700, cursor: ocupado ? "wait" : "pointer", opacity: ocupado ? .6 : 1,
          fontFamily: "var(--font)" }}>
        <Icon name="clock-history" size={11} color="var(--accent)" />
        {ocupado ? "Fichando…" : "Fichar ahora"}
      </button>
      {/* La confirmacion se pinta en una capa a pantalla completa: la barra donde vive este
          control es sticky y la encerraria en su propia altura. */}
      {dialogo && <div style={{ position: "fixed", inset: 0, zIndex: 700 }}>{dialogo}</div>}
    </span>
  );
}
